import { computed, onMounted, ref, watch } from 'vue';
import { useSubscriptionStore } from '@/stores/subscription';
import { useEntitlement } from '@/lib/entitlement';

/** Whether the current user may switch on a paid runner feature such as Monitoring or Metrics. */
export function useMonitoringEntitlement() {
  const store = useSubscriptionStore();
  const checked = ref(store.subscription != null);
  // Another form toggle may load the subscription first.
  watch(
    () => store.subscription,
    (subscription) => {
      if (subscription != null) checked.value = true;
    }
  );

  onMounted(async () => {
    if (checked.value) return;
    try {
      await store.fetchSubscription();
    } catch {
      // Treated as not entitled; the toggle stays disabled.
    } finally {
      checked.value = true;
    }
  });

  const entitled = useEntitlement();
  const canChange = computed(() => checked.value && entitled.value);

  return { canChange };
}
